import type { BrandLang } from './lang.js';
import { Unit } from './unit.js';

export enum BrandKey {
  ATN = 'ATN', // TO
  BEA = 'BEA', // AR
  BIN = 'BIN', // NL // AR
  BRGTS = 'BRGTS', // AR
  BROMM = 'BROMM', // AR
  CAC = 'CAC', // NL // AR // RE // TO
  CAM = 'CAM', // NL // AR // TO
  CAP = 'CAP', // NL // AR // TO
  CBG = 'CBG', // TO
  CLE = 'CLE', // TO
  CTP = 'CTP', // TO
  DEGTS = 'DEGTS', // AR
  DEOMM = 'DEOMM', // AR
  ESGTS = 'ESGTS', // AR
  ESOMM = 'ESOMM', // AR
  FAC = 'FAC', // NL // AR // RE // TO
  FATV = 'FATV', // TO
  FLW = 'FLW', // TO
  FRGTS = 'FRGTS', // NL unit as brand for global use case
  FRGSD = 'FRGSD', // AR
  FRGSG = 'FRGSG', // AR
  FRGSL = 'FRGSL', // AR
  FRGSS = 'FRGSS', // AR
  FRGSV = 'FRGSV', // AR
  FROMM = 'FROMM', // NL // AR
  GAL = 'GAL', // NL // AR // TO
  GEO = 'GEO', // NL // AR // TO
  HBR = 'HBR', // NL // AR // TO
  ITGTS = 'ITGTS', // AR
  ITOMM = 'ITOMM', // AR
  MAN = 'MAN', // TO
  MAD = 'MAD', // TO
  NEO = 'NEO', // NL // AR // TO
  NGE = 'NGE', // TO
  OMM = 'OMM', // TO
  PRA = 'PRA', // TO,
  SHGCAC = 'SHGCAC', // AR
  SHGCAM = 'SHGCAM', // AR
  SHGFAC = 'SHGFAC', // AR
  SHGGEO = 'SHGGEO', // AR
  SHGTEL = 'SHGTEL', // AR
  SHGVOI = 'SHGVOI', // AR
  SIM = 'SIM', // AR
  SRG = 'SRG', // TO
  TEL = 'TEL', // NL // AR // TO
  TGC = 'TGC', // TO
  TLA = 'TLA', // AR
  TLS = 'TLS', // NL // AR // TO
  TRV = 'TRV', // NL
  TVJ = 'TVJ', // TO
  UKGTS = 'UKGTS', // AR
  UKOMM = 'UKOMM', // AR
  VOI = 'VOI', // NL // AR // TO
  HBZ = 'HBZ',

  TESTBRAND = 'TESTBRAND', // TO

  // PMO brands
  UKSAS = 'UKSAS',
  DESAS = 'DESAS',

  // level 0 article category brandKey
  BONE = 'BONE', // AR

  // legacy articles access for ADMIN only
  CTR = 'CTR', // AR
  VDF = 'VDF', // AR

  // CTM brands
  MCE = 'MCE',
  MCO = 'MCO',
  MCS = 'MCS',

  TVS = 'TVS',
}

export const brandKeysByUnit = {
  [Unit.BIN]: [BrandKey.BIN],
  [Unit.CAM]: [BrandKey.CAM],
  [Unit.CBG]: [BrandKey.CBG],
  [Unit.CEBR]: [BrandKey.BRGTS, BrandKey.BROMM],
  [Unit.CEDE]: [BrandKey.DEGTS, BrandKey.DEOMM],
  [Unit.CEES]: [BrandKey.ESGTS, BrandKey.ESOMM],
  [Unit.CEIT]: [BrandKey.ITGTS, BrandKey.ITOMM],
  [Unit.CEUK]: [BrandKey.UKGTS, BrandKey.UKOMM],
  [Unit.CLE]: [BrandKey.CLE],
  [Unit.FATV]: [BrandKey.FATV],
  [Unit.FRGTS]: [
    BrandKey.FRGTS,
    BrandKey.FRGSD,
    BrandKey.FRGSG,
    BrandKey.FRGSL,
    BrandKey.FRGSS,
    BrandKey.FRGSV,
  ],
  [Unit.FROMM]: [BrandKey.FROMM],
  [Unit.GALA]: [BrandKey.GAL],
  [Unit.GEO]: [BrandKey.GEO],
  [Unit.MAD]: [BrandKey.MAD],
  [Unit.NEON]: [BrandKey.NEO],
  [Unit.NGE]: [BrandKey.NGE],
  [Unit.PECO]: [BrandKey.ATN, BrandKey.CAP, BrandKey.HBR, BrandKey.MAN],
  [Unit.PFEM]: [
    BrandKey.BEA,
    BrandKey.CAC,
    BrandKey.FAC,
    BrandKey.FLW,
    BrandKey.OMM,
    BrandKey.PRA,
    BrandKey.SIM,
    BrandKey.SRG,
  ],
  [Unit.PMO]: [BrandKey.UKSAS, BrandKey.DESAS],
  [Unit.PTVS]: [
    BrandKey.CTP,
    BrandKey.CTR,
    BrandKey.TEL,
    BrandKey.TGC,
    BrandKey.TLA,
    BrandKey.TLS,
    BrandKey.TVJ,
  ],
  [Unit.SHG]: [
    BrandKey.SHGCAC,
    BrandKey.SHGCAM,
    BrandKey.SHGFAC,
    BrandKey.SHGGEO,
    BrandKey.SHGTEL,
    BrandKey.SHGVOI,
  ],
  [Unit.TRV]: [BrandKey.TRV],
  [Unit.VOICI]: [BrandKey.VOI],
  [Unit.HBZ]: [BrandKey.HBZ],
  [Unit.CTM]: [BrandKey.MCE, BrandKey.MCO, BrandKey.MCS],
  [Unit.TESTUNIT]: [
    BrandKey.CTR,
    BrandKey.VDF,
    BrandKey.TESTBRAND,
    BrandKey.BONE,
  ],
  [Unit.TVS]: [BrandKey.TVS],
} satisfies Record<Unit, BrandKey[]>;

export const brandTitleByKey = {
  [BrandKey.ATN]: 'Athenee',
  [BrandKey.BEA]: 'Beauté Addict',
  [BrandKey.BIN]: 'Business insider',
  [BrandKey.BRGTS]: 'BR Gentside',
  [BrandKey.BROMM]: 'BR Ohmymag',
  [BrandKey.CAC]: 'Cuisine Actuelle',
  [BrandKey.CAM]: "Ça m'intéresse",
  [BrandKey.CAP]: 'Capital',
  [BrandKey.CBG]: 'Canal + by Prisma',
  [BrandKey.CLE]: 'CLE',
  [BrandKey.CTP]: '100% programme TV',
  [BrandKey.CTR]: 'Ciné Télé Revue',
  [BrandKey.DEGTS]: 'DE Gentside',
  [BrandKey.DEOMM]: 'DE Ohmymag',
  [BrandKey.DESAS]: 'DE Seeandso',
  [BrandKey.ESGTS]: 'ES Gentside',
  [BrandKey.ESOMM]: 'ES Ohmymag',
  [BrandKey.FAC]: 'Femme Actuelle',
  [BrandKey.FATV]: 'FATV',
  [BrandKey.FLW]: 'Flow',
  [BrandKey.FRGTS]: 'FR Gentside',
  [BrandKey.FRGSD]: 'FR Gentside Découverte',
  [BrandKey.FRGSG]: 'FR Gentside Gaming',
  [BrandKey.FRGSL]: 'FR Gentside Lifestyle',
  [BrandKey.FRGSS]: 'FR Gentside Sport',
  [BrandKey.FRGSV]: 'FR Gentside Voyage',
  [BrandKey.FROMM]: 'FR Ohmymag',
  [BrandKey.GAL]: 'Gala',
  [BrandKey.GEO]: 'GEO',
  [BrandKey.HBR]: 'Harvard Business Review',
  [BrandKey.ITGTS]: 'IT Gentside',
  [BrandKey.ITOMM]: 'IT Ohmymag',
  [BrandKey.MAD]: 'MAD',
  [BrandKey.MAN]: 'Management',
  [BrandKey.NEO]: 'Néon',
  [BrandKey.NGE]: 'National Geographic',
  [BrandKey.OMM]: 'Ohmymag',
  [BrandKey.PRA]: 'Prima',
  [BrandKey.SHGCAC]: 'Shopping CAC',
  [BrandKey.SHGCAM]: 'Shopping CAM',
  [BrandKey.SHGFAC]: 'Shopping FAC',
  [BrandKey.SHGGEO]: 'Shopping GEO',
  [BrandKey.SHGTEL]: 'Shopping TEL',
  [BrandKey.SHGVOI]: 'Shopping VOI',
  [BrandKey.SIM]: 'Simone',
  [BrandKey.SRG]: 'Femme Actuelle Senior',
  [BrandKey.TEL]: 'Télé-loisirs',
  [BrandKey.TGC]: 'Ce soir TV',
  [BrandKey.TLA]: 'Télé-loisirs Afrique',
  [BrandKey.TLS]: 'Télé 2 semaines',
  [BrandKey.TRV]: 'Transverse',
  [BrandKey.TVJ]: 'Télé + de jeux + lisible',
  [BrandKey.UKGTS]: 'UK Gentside',
  [BrandKey.UKOMM]: 'UK Ohmymag',
  [BrandKey.UKSAS]: 'UK Seeandso',
  [BrandKey.VDF]: 'Vie de Famille',
  [BrandKey.VOI]: 'Voici',
  [BrandKey.HBZ]: "Harper's Bazaar",

  [BrandKey.TESTBRAND]: 'Test brand',
  [BrandKey.BONE]: 'Bone',
  [BrandKey.MCE]: 'Maisons Côté Est',
  [BrandKey.MCO]: 'Maisons Côté Ouest',
  [BrandKey.MCS]: 'Maisons Côté Sud',
  [BrandKey.TVS]: 'Programmes TV 15 jours',
} satisfies Record<BrandKey, string>;

export function isBrandKey(maybeBrandKey: unknown): maybeBrandKey is BrandKey {
  return Object.entries(BrandKey).some(
    ([, brandKey]) => brandKey === maybeBrandKey,
  );
}

export function assertBrandKey(maybeBrandKey: unknown): BrandKey {
  if (!isBrandKey(maybeBrandKey)) {
    throw new Error(`The brandKey "${maybeBrandKey}" does not exist.`);
  }

  return maybeBrandKey;
}

export function getBrandKeysForUnits(units: Unit[]): BrandKey[] {
  return units.reduce<BrandKey[]>(
    (brandKeys, unit: Unit) => [...brandKeys, ...brandKeysByUnit[unit]],
    [],
  );
}

export function getBrandLang(brandKey: BrandKey): BrandLang {
  const foreignBrandkeys: { [key in BrandKey]?: BrandLang } = {
    [BrandKey.BRGTS]: 'PT',
    [BrandKey.BROMM]: 'PT',
    [BrandKey.DEGTS]: 'DE',
    [BrandKey.DEOMM]: 'DE',
    [BrandKey.DESAS]: 'DE',
    [BrandKey.ESGTS]: 'ES',
    [BrandKey.ESOMM]: 'ES',
    [BrandKey.ITGTS]: 'IT',
    [BrandKey.ITOMM]: 'IT',
    [BrandKey.UKGTS]: 'EN',
    [BrandKey.UKOMM]: 'EN',
    [BrandKey.UKSAS]: 'EN',
  };

  return foreignBrandkeys[brandKey] ?? 'FR';
}
